import { render } from "./pc_destination_description.vue?vue&type=template&id=b3ca1266&scoped=true"
import script from "./pc_destination_description.vue?vue&type=script&scoped=true&lang=js"
export * from "./pc_destination_description.vue?vue&type=script&scoped=true&lang=js"

import "./pc_destination_description.vue?vue&type=style&index=0&id=b3ca1266&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ca1266"]])

export default __exports__